module.exports = __webpack_public_path__ + "img/pollola_s.667670e5.jpg";